module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui text container",
    attrs: {
      "id": "conversor"
    }
  }, [_c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui one column center aligned grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ui basic fluid label top attached"
  }, [_vm._v("\n        Choose how much you want to buy\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "ui three equal width grid"
  }, [_c('div', {
    staticClass: "ui column big input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dollar),
      expression: "dollar"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dollar)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.dollar = $event.target.value
      }, _vm.setDollar],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("USD")])]), _vm._v(" "), _c('div', {
    staticClass: "ui column big input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ether),
      expression: "ether"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.ether)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ether = $event.target.value
      }, _vm.setEther],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("ETH")])]), _vm._v(" "), _c('div', {
    staticClass: "ui column big input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ant),
      expression: "ant"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.ant)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.ant = $event.target.value
      }, _vm.setANT],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("ANT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('button', {
    staticClass: "ui huge center aligned fluid inverted basic button",
    class: _vm.termsAccepted ? '' : 'disabled',
    on: {
      "click": _vm.buyTokens
    }
  }, [_vm._v("Buy tokens")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64676531"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conversor.vue
// module id = 515
// module chunks = 1